import { ErrorRequestHandler, NextFunction, Request, Response } from 'express'

export const error_middleware = (
  err: ErrorRequestHandler,
  req: Request,
  res: Response,
  next: NextFunction,
) => {
  console.log(err)
  res.status(500).json({ error: `Internal Server Error ${err}` })
}
